import { Stack, Typography } from '@mui/material';
import React from 'react';

import { EmptyCardContentContainer } from '@/console/features/card-layout/components/empty-card/empty-card.styled';
import { TEmptyCardProps } from '@/console/features/card-layout/components/empty-card/empty-card.types';

export const EmptyCard: React.FC<TEmptyCardProps> = ({
  icon,
  text,
  action,
}) => {
  return (
    <EmptyCardContentContainer>
      <Stack spacing={4} alignItems="center">
        {icon}
        <Typography>{text}</Typography>
      </Stack>
      {action}
    </EmptyCardContentContainer>
  );
};
